import { AccountDetails, Beneficiary, IraPlan } from '../types'

// returns "••XXXX"
export const bulletedLastFour = (acctNum?: string): string => {
  if (!acctNum) {
    return ''
  }
  return `\u2022\u2022${acctNum.slice(-4)}`
}

// Formats based on a given account to:
// My Savings ••0772
// or
// Savings Account ••0772
export const standardAccountLabel = (acct?: AccountDetails): string => {
  if (!acct) return ''

  const name = `${acct.accountNickname || `${acct.productDescription}`}`
  return `${name} ${bulletedLastFour(acct.accountNumberPvtEncrypt)}`
}

export const standardIraPlanAccountLabel = (acct?: IraPlan): string => {
  // istanbul ignore next - low value //
  if (!acct) return ''

  return `${acct.planType} IRA Plan ${bulletedLastFour(acct.planNumber)}`
}

export const getBeneficiaryDisplayName = (bene: Beneficiary): string => {
  if (bene.beneficiaryName) {
    return bene.beneficiaryName
  }
  if (bene.middleName) {
    return `${bene.firstName} ${bene.middleName} ${bene.lastName}`
  }
  return `${bene.firstName} ${bene.lastName}`
}

export function getAllocationPercentage(percentage: string): string {
  if (percentage.toLowerCase() === 'equal') {
    return percentage
  }
  return `${Math.floor(parseInt(percentage, 10))}%`
}

export const maskSSN = (value: string): string => {
  return value && value.length === 11
    ? `\u2022\u2022\u2022-\u2022\u2022-${value.slice(-4)}`
    : value
}

export const maskTaxId = (value: string): string => {
  return value && value.length === 10
    ? `\u2022\u2022-\u2022\u2022\u2022${value.slice(-4)}`
    : value
}

// Return error message if it exists, otherwise stringify, useful in catch blocks
export const getErrorMessage = (error: unknown): string => {
  if (error instanceof Error) return error.message
  return String(error)
}

export const removeLeadingZeros = (
  value: string | number | undefined,
): string => {
  if (!value) return ''
  return value.toString().replace(/^0+/, '')
}

export const convertDateToSafeFormat = (value: string): string => {
  return value.replace(/-/g, '/')
}

export function formatDOB(dateString?: string): string {
  // Returns formatted date as Feb 2, 2001 or empty string
  // UTC timezone prevents browser from changing the date based on timezone
  return dateString
    ? new Date(dateString).toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC',
      })
    : ''
}

export function formatDOBforInput(dateString?: string): string {
  // Returns formatted date as 02/02/2001 or empty string
  if (!dateString) return ''

  const dob = new Date(formatDOB(dateString))
  const dobMonth = (dob.getMonth() + 1).toLocaleString('en-US', {
    minimumIntegerDigits: 2,
    useGrouping: false,
  })
  const dobDay = dob
    .getDate()
    .toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
  const dobYear = dob.getFullYear()

  return `${dobMonth}/${dobDay}/${dobYear}`
}
